import { render, staticRenderFns } from "./insertWatermark.vue?vue&type=template&id=06ec6db0&scoped=true"
import script from "./insertWatermark.vue?vue&type=script&lang=js"
export * from "./insertWatermark.vue?vue&type=script&lang=js"
import style0 from "./insertWatermark.vue?vue&type=style&index=0&id=06ec6db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ec6db0",
  null
  
)

export default component.exports